import {
  ACTIVO_TIPOS_AREAS,
  CLEAR_ALL,
  GETALL_TIPOS_AREAS,
  LOADING_GETALL_TIPOS_AREAS,
  PARAMS_TIPOS_AREAS,
  SET_LOGOUT,
} from '../../store/Types';

const initialState = {
  all: [],
  loadingGetAll: false,
  activo: null,
  params: {},
};

export const tiposAreasReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_TIPOS_AREAS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_TIPOS_AREAS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_GETALL_TIPOS_AREAS:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case PARAMS_TIPOS_AREAS:
      return {
        ...state,
        params: action.payload,
      };
    case SET_LOGOUT || CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
